import ProtectedMenuItemLink from "../ProtectedMenuItemLink";
import React, { FC } from "react";
import SettingsIcon from "@material-ui/icons/Settings";
import { useSelector } from "react-redux";
import { AppState } from "../Menu";
import SectionComponent from "../SectionComponent";

interface AdminDataAndToolsMenuProps {
  permissions: string[];
}

const AdminDataAndToolsMenu: FC<AdminDataAndToolsMenuProps> = ({
  permissions,
}) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);

  const availableResources = ["users", "calculateCostFeatures", "exportDataFeatures"];

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    availableResources.includes(permission),
  );
  if (findResources.length === 0) {
    return <></>;
  }

  return (
    <SectionComponent name={open ? "Admin Data & Tools" : "AD & T"}>
      <ProtectedMenuItemLink
        to={`/calculateCostFeatures`}
        primaryText={"Calculate Cost Features"}
        leftIcon={<SettingsIcon />}
        permissions={permissions}
        permissionResource="calculateCostFeatures"
      />

      <ProtectedMenuItemLink
        to={`/exportDataFeatures`}
        primaryText={"Export Data Features"}
        leftIcon={<SettingsIcon />}
        permissions={permissions}
        permissionResource="exportDataFeatures"
      />

      <ProtectedMenuItemLink
        to={`/users`}
        primaryText={"Users"}
        leftIcon={<SettingsIcon />}
        permissions={permissions}
        permissionResource="users"
      />
    </SectionComponent>
  );
};

export default AdminDataAndToolsMenu;
